'use client';

import { Modal as MUIModal } from '@mui/material';
import { ReactNode } from 'react';

type ModalProps = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  width?: string;
};

export function Modal({ open, onClose, children, width = '100%' }: ModalProps) {
  return (
    <MUIModal open={open} onClose={onClose}>
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width,
          height: '100svh',
          margin: '4rem auto',
          outline: 'none',
        }}
      >
        {children}
      </div>
    </MUIModal>
  );
}
